import { EWorldAction } from 'libs/utils/world/worldTypes';
import { LngLatBounds } from 'mapbox-gl';
import {
    ICoordinates,
    IDrawWorldMarker,
    IImageWorldMarker,
    ILinkWorldMarker,
    IPinWorldMarker,
    IPolygonWorldMarker,
    ITextWorldMarker,
    IWorldMarker,
    IYoutubeWorldMarker,
    ORIGIN_ZOOM,
    getInScale
} from 'react-give-me-map';

export function keepAlphanumeric(val: string) {
    return val ? val.replace(/[^a-z0-9]+|\s+/gim, '') : '';
}

export function keepNumeric(val: string) {
    return val ? val.replace(/[^0-9]+|\s+/gim, '') : '';
}

export function keepAlphanumericHashSpace(val: string) {
    return val ? val.replace(/[^a-z0-9# ]+|/gim, '').replace(/ {2,}/g, ' ') : '';
}

export function isSpecialControlAction(type: EWorldAction): boolean {
    return type === EWorldAction.DRAW;
}

export function getMarkerScale(m: Pick<IWorldMarker, 'scalable' | 'scale'>, zoom: number) {
    return m.scalable ? getInScale(m.scale, ORIGIN_ZOOM, zoom) : 1;
}

export type SinglePointMultiSelectableMarker =
    | ITextWorldMarker
    | IImageWorldMarker
    | IDrawWorldMarker
    | IPinWorldMarker
    | IPolygonWorldMarker
    | IYoutubeWorldMarker
    | ILinkWorldMarker;

export function isSinglePointMultiSelectable(
    marker: IWorldMarker
): marker is SinglePointMultiSelectableMarker {
    return !['route', 'direction'].includes(marker.elementType);
}

export const normalizeLng = (val: number) => {
    if (!val) {
        return val;
    }

    let newVal = val;
    while (newVal > 180) {
        newVal -= 360;
    }

    while (newVal < -180) {
        newVal += 360;
    }

    return newVal;
};

export const normalizeLat = (val: number) => {
    if (!val) {
        return val;
    }

    let newVal = val;
    while (newVal > 90) {
        newVal -= 180;
    }

    while (newVal < -90) {
        newVal += 180;
    }

    return newVal;
};

export const boundCoordinateToEdges = (coordinate: ICoordinates) => {
    const { lat, lng } = coordinate;
    const getLat = () => {
        if (lat < 0 && lat < -90) return -90;
        if (lat > 0 && lat > 90) return 90;
        return lat;
    };

    const getLng = () => {
        if (lng < 0 && lng < -180) return -180;
        if (lng > 0 && lng > 180) return 180;
        return lng;
    };

    return { lat: getLat(), lng: getLng() };
};

export function getCoordinateBounds(coordinates: ICoordinates[]) {
    const bounds = new LngLatBounds(coordinates[0], coordinates[0]);

    for (const coord of coordinates) {
        bounds.extend(coord);
    }

    return bounds;
}
